import React from 'react';
import styled from 'styled-components';

import constants from 'utils/constants'

import redFire from 'images/character/red_fire-94x119.png';
import orangeFire from 'images/character/orange_fire-69x88.png';
import yellowFire from 'images/character/yellow_fire-59x74.png';

export default function AchievementRateItem({userInfo, achievementRateItem, index}) {
    let fireImg = null;
    if(index === 0 && achievementRateItem['rate'] !== 0)
    {
        fireImg = {
            img: redFire,
            width: 'calc(100vw * (40.71 / 375))',
            height: 'calc(100vw * (53.55 / 375))',
            top: 'calc(100vw * (-14 / 375))',
            left: 'calc(100vw * (7 / 375))'
        }
    }
    else if(index === 1 && achievementRateItem['rate'] !== 0)
    {
        fireImg = {
            img: orangeFire,
            width: 'calc(100vw * (36.29 / 375))',
            height: 'calc(100vw * (45.62 / 375))',
            top: 'calc(100vw * (-5.31 / 375))',
            left: 'calc(100vw * (13 / 375))'
        }
    }
    else if(index === 2 && achievementRateItem['rate'] !== 0)
    {
        fireImg = {
            img: yellowFire,
            width: 'calc(100vw * (32 / 375))',
            height: 'calc(100vw * (40 / 375))',
            top: 'calc(100vw * (-2 / 375))',
            left: 'calc(100vw * (15 / 375))'
        }
    }
    const isBorder = userInfo['id'] === achievementRateItem['user_no'];
    return (
        <AchievementRateItemBlock border={isBorder}>
            {fireImg !== null ? (
                <FireIconBlock width={fireImg['width']} height={fireImg['height']} top={fireImg['top']} left={fireImg['left']}>
                    <FireIcon src={fireImg['img']}/>
                </FireIconBlock>
            ) : null}
            <UserProfileImgBlock>
                <UserProfileImg src={`${constants.imagePath}/user_profile_img/${achievementRateItem['profile_img']}`}/>
                {achievementRateItem['user_num'] !== 0 && achievementRateItem['user_num'] - 1 !== 0 ?
                    <AditinalUserNumBlock>+{achievementRateItem['user_num'] - 1}</AditinalUserNumBlock>
                    :
                    null
                }
            </UserProfileImgBlock>
            <AchievementRateInfoBlock>
                <AchievementRateInfoTop>
                    <UserNickName>{achievementRateItem['nickname']}</UserNickName>
                    <ProgressPercent>{`${achievementRateItem['rate']}%`}</ProgressPercent>
                </AchievementRateInfoTop>
                <AchievementRateInfoBottom>
                    <ProgressBarBlock>
                        <ProgressbarLine width={achievementRateItem['rate']}/>
                    </ProgressBarBlock>
                </AchievementRateInfoBottom>
            </AchievementRateInfoBlock>
        </AchievementRateItemBlock>
    );
}

const AchievementRateItemBlock = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    width: calc(100vw * (341 / 375));
    height: calc(100vw * (79 / 375));
    background-color: #fff;
    border-radius: calc(100vw * (10 / 375)); 
    margin-bottom: calc(100vw * (12 /375));
    padding: calc(100vw * (15 / 375)) calc(100vw * (50 / 375)) calc(100vw * (15 / 375)) calc(100vw * (32 / 375));
    border: ${({border}) => border ? '1.5px solid #FFCF19;' : 'none'};
    box-shadow: ${({border}) => border ? '0px 0px 20px #FFF1C4' : 'none'};
`;

const UserProfileImgBlock = styled.div`
    position: relative;
    width: calc(100vw * (50 / 375));
    height: calc(100vw * (50 / 375));
    border-radius: 50%;
    border: 1px solid #f7f7f7;
`;

const UserProfileImg = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%; 
    object-fit: cover;
`;

const AchievementRateInfoBlock = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: calc(100vw * (21 / 375));
`;

const AchievementRateInfoTop = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: calc(100vw * (12 / 375));
`;

const UserNickName = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    line-height: calc(100vw * (20.27 / 375));
`;

const ProgressPercent = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 700;
    line-height: calc(100vw * (20.27 / 375));
`;

const AchievementRateInfoBottom = styled.div`
`;

const ProgressBarBlock = styled.div`
    position: relative;
    width: 100%;
    height: calc(100vw * (6 / 375));
    background: #F7F7F7;
    border-radius: calc(100vw * (22 / 375));
`;

const ProgressbarLine = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: ${({width}) => width}%;
    height: 100%;
    background-color: #121212;
    border-radius: calc(100vw * (22 / 375));
`;

const AditinalUserNumBlock = styled.div`
    position: absolute;
    top: calc(100vw * (6.67 / 375));
    left: calc(100vw * (32 / 375));
    width: calc(100vw * (30.09 / 375));
    height: calc(100vw * (30.23 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E6E6E6;
    border-radius: 50%;
    font-size: calc(100vw * (12 / 375));
    font-weight: bold;
    line-height: 150%;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #414141;
    border: 1.5px solid #fff;
`;

const FireIconBlock = styled.div`
    position: absolute;
    width: ${({width}) => width};
    height: ${({height}) => height};
    top: ${({top}) => top};
    left: ${({left}) => left};
    z-index: 10;
`;

const FireIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;